import type { IntlShape } from 'react-intl'
import getLPCRegionLOS from './getLPCRegionLOS'

export default function getOfferDurationText(
  intl: IntlShape,
  offer: App.Offer | App.OfferSummary,
  pkg: App.Package,
): string {
  if (offer.type === 'rental' && offer.lowestPricePackage) {
    return intl.formatMessage(
      {
        id: 'uLvkNC7zKBL7p1MmWGtU',
        defaultMessage: '{durationLabel} from',
        description: 'Rental offer duration label with "from" suffix on offer card',
      },
      { durationLabel: offer.lowestPricePackage.durationLabel.toLocaleLowerCase() },
    )
  }
  if (pkg.duration) {
    return intl.formatMessage(
      {
        id: 'bpRr7kqMdQCHkQ_UR10Z',
        defaultMessage: '{count, plural, one {# night} other {# nights}} from',
        description: 'Package duration in nights with "from" suffix on offer card',
      },
      { count: pkg.duration },
    )
  }
  if (offer.tileDurationLabel) {
    return intl.formatMessage(
      {
        id: 'qfUz447wt6urAVvxwyJU',
        defaultMessage: '{durationLabel} from',
        description: 'Tile duration label with "from" suffix on offer card',
      },
      { durationLabel: offer.tileDurationLabel.toLocaleLowerCase() },
    )
  }
  const LPCRegionLOS = getLPCRegionLOS(offer)
  if (LPCRegionLOS) {
    return intl.formatMessage(
      {
        id: '0xkXKLduSGUiZzmYMVkA',
        defaultMessage: '{count, plural, one {# night} other {# nights}} from',
        description: 'LPC region length of stay in nights with "from" suffix on offer card',
      },
      { count: LPCRegionLOS },
    )
  }
  return intl.formatMessage({
    id: 'sqYce3N9moI3ZGynV3ab',
    defaultMessage: 'From',
    description: 'Fallback "From" label on offer card when no duration is available',
  })
}
